import { AthenaEventSaveErrorReason } from "./AthenaEventSaveErrorReason.js";
export function makeUniqueViolation(details) {
    return {
        reason: AthenaEventSaveErrorReason.UniqueViolation,
        retryable: false,
        details: details,
    };
}
export function makeValidation(details) {
    return {
        reason: AthenaEventSaveErrorReason.Validation,
        retryable: false,
        details: details,
    };
}
export function makeUnauthorized(details) {
    return {
        reason: AthenaEventSaveErrorReason.Unauthorized,
        retryable: true,
        details: details,
    };
}
export function makeAddition(details) {
    return {
        reason: AthenaEventSaveErrorReason.Addition,
        retryable: false,
        details: details,
    };
}
export function makeBackendUnreachable(details) {
    return {
        reason: AthenaEventSaveErrorReason.BackendUnreachable,
        retryable: true,
        details: details,
    };
}
export function makeUnknown(details) {
    return {
        reason: AthenaEventSaveErrorReason.Unknown,
        retryable: true,
        details: details,
    };
}
//# sourceMappingURL=AthenaEventSaveError.js.map